<kendo-grid #kendoGrid
            [data]='gridWrapper.gridData'
            [loading]='gridWrapper.loading'
            [height]='(bodyHeight$|async) || 400'
            scrollable='virtual'
            rowHeight='54px'
            [skip]='gridWrapper.gridState.skip'
            [pageSize]='gridWrapper.gridState.take'
            kendoGridSelectBy='id'
            [selectedKeys]='gridWrapper.mySelection'
            [sortable]='true'
            [groupable]='true'
            [group]='gridWrapper.gridState.group'
            [sort]='gridWrapper.gridState.sort'
            (groupChange)='gridWrapper.groupChanged($event)'
            (dataStateChange)='gridWrapper.onDataStateChange($event)'
            [resizable]='true'
            filterable='menu'
            (filterChange)='filterChange($event)'>

  <kendo-grid-messages
    [noRecords]="gridWrapper.loading ? '' : 'Aucun résultat'"
    filterClearButton='Effacer'
    filterFilterButton='Filtrer'
    groupPanelEmpty="Déplacer ici l'entête d'une colonne pour grouper...">
  </kendo-grid-messages>

  <ng-template kendoGridToolbarTemplate>
    <input #mainFilter placeholder='Rechercher...' kendoTextBox (input)='gridWrapper.onFilter($event.target)' />
    <button mat-icon-button
            color='primary'
            [style.visibility]="mainFilter.value.length > 0 ? 'visible' : 'hidden'"
            (click)="mainFilter.value=''; gridWrapper.clearFilter()">
      <mat-icon>clear</mat-icon>
    </button>
  </ng-template>

  <kendo-grid-column field='idSegment' title='Segment' [width]='150' filterable='false' [groupable]='false'>
  </kendo-grid-column>
  <kendo-grid-column field='descriptionType' title='Type' [width]='180'>
    <ng-template kendoGridFilterMenuTemplate
                 let-column='column'
                 let-filter='filter'
                 let-filterService='filterService'>

      <app-multicheck-filter
        [isPrimitive]='true'
        [field]='column.field'
        [filterService]='filterService'
        [currentFilter]='filter'
        [data]='distinctPrimitive(column.field)'
      ></app-multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field='pgm.description' title='PGM' [width]='150' filterable='false'>
  </kendo-grid-column>
  <kendo-grid-column field='pgm.commentaire' title='Localisation' filterable='false'>
  </kendo-grid-column>
  <kendo-grid-column field='pgm.descriptionMode' title='Mode' [width]='220'>
    <ng-template kendoGridFilterMenuTemplate
                 let-column='column'
                 let-filter='filter'
                 let-filterService='filterService'>

      <app-multicheck-filter
        [isPrimitive]='true'
        [field]='column.field'
        [filterService]='filterService'
        [currentFilter]='filter'
        [data]='distinctPrimitiveMode(column.field)'
      ></app-multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field='pgm.descriptionEtatDetaille' title='Etat' [width]='220'>
    <ng-template kendoGridFilterMenuTemplate
                 let-column='column'
                 let-filter='filter'
                 let-filterService='filterService'>

      <app-multicheck-filter
        [isPrimitive]='true'
        [field]='column.field'
        [filterService]='filterService'
        [currentFilter]='filter'
        [data]='distinctPrimitiveEtat(column.field)'
      ></app-multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field='id' title='Actions' [width]='100' [filterable]='false' [groupable]='false'>
    <ng-template kendoGridCellTemplate let-dataItem>
      <div fxLayout='row' fxLayoutAlign='center center'>
        <button mat-icon-button
                color='primary'
                (click)='zoomTo($event, dataItem)' matTooltip='Voir sur la carte'>
          <mat-icon>zoom_in</mat-icon>
        </button>
        <button *ngIf='dataItem.pgm?.idMode === 4' mat-icon-button (click)='toogleAvancement($event, dataItem)'
                color='primary'
                matTooltip="Visualiser l'avancement">
          <mat-icon>open_in_new</mat-icon>
        </button>
      </div>
    </ng-template>
  </kendo-grid-column>
</kendo-grid>





